var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { color: "#0b0b0b" } },
    [
      _c(
        "div",
        {
          staticClass: "importantTipsCont",
          staticStyle: { "margin-bottom": "10px", display: "block" },
        },
        [
          _c("div", { staticClass: "cancelThisMDFe" }, [
            _vm._v(
              _vm._s(_vm.$t("mdfeTranslate.AreYouSureYouWantToCancelThisMDFe"))
            ),
          ]),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t("mdfeTranslate.ThisOperationWillCancelTheEntireMDFe")
              )
            ),
          ]),
        ]
      ),
      _c("div", { staticClass: "applicableScenarios" }, [
        _vm._m(0),
        _c("div", { staticClass: "applicableCont" }, [
          _c("div", { staticClass: "applicableTitle" }, [
            _vm._v(_vm._s(_vm.$t("mdfeTranslate.ApplicableTime"))),
          ]),
          _c("div", [
            _vm._v(
              " " + _vm._s(_vm.$t("mdfeTranslate.CanOnlyBeCancelled")) + " "
            ),
            _c("span", { staticStyle: { color: "#d52526" } }, [
              _vm._v(_vm._s(_vm.$t("mdfeTranslate.Within24Hours"))),
            ]),
            _vm._v(" " + _vm._s(_vm.$t("mdfeTranslate.Cancelable")) + " "),
          ]),
        ]),
      ]),
      _c("el-divider", { staticStyle: { margin: "10px 0" } }),
      _c("div", { staticClass: "applicableScenarios" }, [
        _vm._m(1),
        _c("div", { staticClass: "applicableCont" }, [
          _c("div", { staticClass: "applicableTitle" }, [
            _vm._v(_vm._s(_vm.$t("mdfeTranslate.ApplicableScenarios"))),
          ]),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "mdfeTranslate.OnlyUsedForInputErrorsOrDuplicateSituations"
                )
              )
            ),
          ]),
          _c("div", { staticStyle: { color: "#d52526" } }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "mdfeTranslate.CannotBeCancelledOnceTheShipmentHasStarted"
                )
              )
            ),
          ]),
        ]),
      ]),
      _c("el-divider"),
      _c("div", { staticClass: "operationResultCont" }, [
        _vm._m(2),
        _c("div", { staticClass: "applicableCont" }, [
          _c("div", { staticClass: "applicableTitle" }, [
            _vm._v(_vm._s(_vm.$t("mdfeTranslate.OperationResult"))),
          ]),
          _c("div", [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("mdfeTranslate.AfterCancellation"))),
            ]),
            _c("span", { staticStyle: { color: "#d52526" } }, [
              _vm._v(_vm._s(_vm.$t("mdfeTranslate.Canceled"))),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "importantTipsCont",
          staticStyle: { "margin-bottom": "10px" },
        },
        [
          _vm._m(3),
          _c("div", { staticClass: "applicableCont" }, [
            _c("div", { staticClass: "importantTips" }, [
              _vm._v(_vm._s(_vm.$t("mdfeTranslate.ImportantTips"))),
            ]),
            _c("div", [
              _vm._v(
                _vm._s(_vm.$t("mdfeTranslate.CancellationCannotBeRecovered"))
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            { staticStyle: { "font-size": "16px", "font-weight": "bold" } },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("mdfeTranslate.CancellationReason")) + " "
              ),
            ]
          ),
          _c("div", [
            _vm._v(
              _vm._s(_vm.$t("mdfeTranslate.ToFacilitateSubsequentManagement"))
            ),
          ]),
          _c("el-input", {
            attrs: {
              type: "textarea",
              rows: 3,
              placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
            },
            model: {
              value: _vm.cancelReason.cancellationReason,
              callback: function ($$v) {
                _vm.$set(_vm.cancelReason, "cancellationReason", $$v)
              },
              expression: "cancelReason.cancellationReason",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "applicableScenariosCont" }, [
      _c("i", { staticClass: "el-icon-time" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "iconfontCont" }, [
      _c("i", { staticClass: "iconfont icon-a-ziyuan106" }),
      _c("div", { staticClass: "iconfontError" }, [
        _c("i", { staticClass: "el-icon-error" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "iconfontCont" }, [
      _c("i", { staticClass: "el-icon-document" }),
      _c("div", { staticClass: "iconfontError" }, [
        _c("i", { staticClass: "el-icon-error" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { width: "60px" } }, [
      _c("i", { staticClass: "iconfont icon-a-zu665" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }